import React from 'react';
import InlineMessage from '@atlaskit/inline-message';
import './billed-elsewhere-badge.scss';

const BilledElsewhereBadge = ({ className }: { className?: string }) => {
  return (
    <div className={`BilledElsewhereBadge ${className}`}>
      <InlineMessage type="info" iconLabel="Log in to see more information" secondaryText={<div>Billed elsewhere</div>}>
        <p className="inline-dialog-content">
          Billing for this product is currently managed in{' '}
          <a href="https://ifountain.app.opsgenie.com/" target="_blank" rel="noreferrer">
            Opsgenie
          </a>
        </p>
      </InlineMessage>
    </div>
  );
};

export default BilledElsewhereBadge;
